/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContratHistoryGridDto } from './ContratHistoryGridDto';
import {
    ContratHistoryGridDtoFromJSON,
    ContratHistoryGridDtoFromJSONTyped,
    ContratHistoryGridDtoToJSON,
} from './ContratHistoryGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ContratHistoryGridDtoPaginatedResults
 */
export interface ContratHistoryGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ContratHistoryGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ContratHistoryGridDto>}
     * @memberof ContratHistoryGridDtoPaginatedResults
     */
    results?: Array<ContratHistoryGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ContratHistoryGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ContratHistoryGridDtoPaginatedResults interface.
 */
export function instanceOfContratHistoryGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContratHistoryGridDtoPaginatedResultsFromJSON(json: any): ContratHistoryGridDtoPaginatedResults {
    return ContratHistoryGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ContratHistoryGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContratHistoryGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ContratHistoryGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ContratHistoryGridDtoPaginatedResultsToJSON(value?: ContratHistoryGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ContratHistoryGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

